import { UserAccountDto } from '@api/client';

export function resolveActiveAccount(
  accounts: UserAccountDto[],
  selectedAccountId: number | undefined,
): UserAccountDto | undefined {
  return accounts.find(account => account.id === selectedAccountId) ?? accounts[0];
}

/**
 * A strategy subaccount is run from the embedded CoinLion UI and cannot trade, so it is the one
 * account type the OTC views must never be opened for.
 */
export function isStrategyAccount(account: UserAccountDto | undefined): boolean {
  return account?.subAccountType === UserAccountDto.SubAccountTypeEnum.Strategy;
}
